<template>
  <v-container 
    :class="['container-full-bg-gray', { 'bank-account-list--mobile': isMobile }]"
    fluid
  >
    <bank-connector v-if="currentCompany && contractBankActive && currentCompany.id" :company_id="currentCompany.id"/>
    <bank-trial v-else-if="contractBankActive === false"></bank-trial>
  </v-container>
</template>


<script>
  import BankConnector from "@/components/BankConnector.vue";
  import BankTrial from "@/components/BankTrial.vue";
  import { ContractBankQuery } from "@/modules/bank/application/ContractBankQuery";
  import { query_dispatcher } from "@/api/client";
  import { mapGetters, mapState } from 'vuex';
  export default {
    name: 'BankAccountList',
    data() {
      return {
        contractBankActive: null,
      }
    },
    computed: {
      ...mapGetters({
        userData: 'me/userData',
        isMobile: 'is_mobile'
      }),
      ...mapState(['currentCompany']),
    },
    components: {    
      BankConnector,
      BankTrial,
    },
    async mounted() {         
      this.getBankContract();
    },
    methods: {  
      async getBankContract() {
        try {      
            await new ContractBankQuery(query_dispatcher, this).run();
        } catch(error) {
            console.error('Error ContractBankQuery:', error);
        }
      }
    }
  }
  </script> 

<!-- Mobile BankAccountList -->
<style>
.bank-account-list--mobile {
  overflow-y: hidden !important;

  padding: 0 !important;

  .v-card__title {
    padding: 0 !important;

    .col{
      padding: 0 !important;
    }

    .flex-grow-1.col {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  }

  thead > tr > th{
      border: 1px solid #ccc;
      border-radius: 0 !important;
  }

  .container {
      padding: 0 !important;
  }

  .app-col--no-input-fields-above{
      padding: 0 !important;
  }

  .v-data-table__wrapper {
    min-height: calc(100vh - 220px); 
    max-height: calc(100vh - 220px);
    overflow-y: auto;
    border-radius: 0 !important;

    table {
      tbody > tr {
        td:first-child {
          background-color: #5C3D8F !important;

          .theme--light.v-icon{
            color: white !important;
          }
        }
        td {
          border: 1px solid gray;
        }
      }
    }
  }

  .v-data-footer{
    margin: 0 !important;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    height: 65px;

    .v-data-footer__select{
      margin: 0 !important;
      display: none !important;
    }
  }

  .v-card__text{
    padding: 0 !important;
  }

  .v-data-table-header-mobile__wrapper{
    width: fit-content;
    min-height: 8vh
  }

  .v-text-field{
    padding-top: 0 !important; 
    margin-top: 0 !important;
  }

  .v-input{
    margin-top:16px !important;
  }
}
</style>